import React from 'react';
import HeroSection from '../HeroSection';

function Home() {
  return (
    <>
        <div data-testid={"section"}></div>
      <HeroSection  />
    </>
  );
}

export default Home;
